const startingColor = '#0074D9'
const endingColor = '#2ECC40'

export {
	startingColor,
	endingColor,
}
